import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";

const useUser = () => {
  const { userId, accountId } = useSelector((state: RootState) => state.monday);

  return {
    userId,
    accountId,
  };
};

export default useUser;
